class CollectionEnhancer {
  constructor() {
    this.sortSelect = document.getElementById('SortBy');
    this.filterToggle = document.querySelector('[data-filter-toggle]');
    this.filterSidebar = null;

    this.init();
  }

  init() {
    this.bindEvents();
    this.createFilterSidebar();
  }

  bindEvents() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this.handleSortChange.bind(this));
    }

    if (this.filterToggle) {
      this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
    }
  }

  createFilterSidebar() {
    const filtersContent = document.getElementById('collection-filters-content');
    if (!filtersContent) return;

    const sidebar = document.createElement('div');
    sidebar.className = 'collection__filter-sidebar';
    sidebar.innerHTML = `
      <div class="filter-sidebar__overlay"></div>
      <div class="filter-sidebar__content">
        <div class="filter-sidebar__header">
          <h3>Filtres</h3>
          <button type="button" class="filter-sidebar__close" aria-label="Fermer">&times;</button>
        </div>
        <div class="filter-sidebar__body">
          ${filtersContent.innerHTML}
        </div>
      </div>
    `;
    document.body.appendChild(sidebar);
    this.filterSidebar = sidebar;

    const overlay = sidebar.querySelector('.filter-sidebar__overlay');
    const closeBtn = sidebar.querySelector('.filter-sidebar__close');
    const form = sidebar.querySelector('[data-filters-form]');

    overlay.addEventListener('click', this.closeFilters.bind(this));
    closeBtn.addEventListener('click', this.closeFilters.bind(this));

    if (form) {
      form.addEventListener('submit', this.handleFilterSubmit.bind(this));
    }

    if (typeof lucide !== 'undefined') {
      lucide.createIcons({ nameAttr: 'data-lucide' });
    }
  }

  handleFilterSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);
    const url = new URL(window.location.href);

    const currentSort = url.searchParams.get('sort_by');

    url.search = '';

    if (currentSort) {
      url.searchParams.set('sort_by', currentSort);
    }

    for (const [key, value] of formData.entries()) {
      if (value) {
        url.searchParams.append(key, value);
      }
    }

    this.showLoadingState();
    window.location.href = url.toString();
  }

  toggleFilters() {
    if (this.filterSidebar.classList.contains('is-active')) {
      this.closeFilters();
    } else {
      this.openFilters();
    }
  }

  openFilters() {
    this.filterSidebar.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  closeFilters() {
    this.filterSidebar.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  handleSortChange(event) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  showLoadingState() {
    const grid = document.querySelector('.collection__grid');
    if (grid) {
      grid.style.opacity = '0.6';
      grid.style.pointerEvents = 'none';
    }

    const loading = document.createElement('div');
    loading.className = 'collection-loading';
    loading.innerHTML = `
      <div class="collection-loading__content">
        <div class="collection-loading__spinner"></div>
        <span>Chargement...</span>
      </div>
    `;

    const main = document.querySelector('.collection__grid');
    if (main) {
      main.parentNode.insertBefore(loading, main);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionEnhancer();
});
